//Custom states
export const registerStates = (states) => {


    states.customState = (state = {}, action) => {
        switch (action.type) {
            case 'PAGE_SCROLLED':
                return {
                    ...state,
                    scrolled: action.scrolled
                }
            case 'PAGE_LOADING':
                return {
                    ...state,
                    menu_toggled: false
                }
            case 'MENU_TOGGLED':
                return {
                    ...state,
                    menu_toggled: !state.menu_toggled,
                    usermenu_toggled: false
                }
            default:
                return state;
        }
    }



    return states;
}